import { AWSKey } from '../env';

export function getAuthHeaders() {
  return {
    'x-api-key': `${AWSKey}`,
  };
}
